export const hintId = (inputId: string) => `${inputId}-hint`
export const errorId = (inputId: string) => `${inputId}-error`
